/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ event: NonNullable<unknown> }} Email_Reminder_SubjectInputs */

const th_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} กำลังจะเริ่ม`)
};

const en_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} starts soon`)
};

const ja_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} がまもなく始まります`)
};

const zh_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 即将开始`)
};

const es_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} empieza pronto`)
};

const pt_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} começa em breve`)
};

const id_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} segera dimulai`)
};

const fr_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} commence bientôt`)
};

const tl_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Malapit nang magsimula ang ${i?.event}`)
};

const vi_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} sắp bắt đầu`)
};

const ko_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event}이(가) 곧 시작합니다`)
};

const de_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} beginnt bald`)
};

const ru_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} скоро начнётся`)
};

const tr_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} yakında başlıyor`)
};

const it_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} sta per iniziare`)
};

const pl_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} wkrótce się zaczyna`)
};

const uk_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} скоро починається`)
};

const hi_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} जल्द शुरू हो रहा है`)
};

const ar_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} على وشك البدء`)
};

const ms_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} akan bermula tidak lama lagi`)
};

const bn_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} শীঘ্রই শুরু হচ্ছে`)
};

const zh_tw2_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 即將開始`)
};

const zh_hk2_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} 即將開始`)
};

const ur_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} جلد شروع ہو رہا ہے`)
};

const fa_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} به‌زودی آغاز می‌شود`)
};

const sw_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} unakaribia kuanza`)
};

const nl_email_reminder_subject = /** @type {(inputs: Email_Reminder_SubjectInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.event} begint binnenkort`)
};

/**
* | output |
* | --- |
* | "{event} starts soon" |
*
* @param {Email_Reminder_SubjectInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const email_reminder_subject = /** @type {((inputs: Email_Reminder_SubjectInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Email_Reminder_SubjectInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_email_reminder_subject(inputs)
	if (locale === "ja") return ja_email_reminder_subject(inputs)
	if (locale === "zh") return zh_email_reminder_subject(inputs)
	if (locale === "es") return es_email_reminder_subject(inputs)
	if (locale === "pt") return pt_email_reminder_subject(inputs)
	if (locale === "id") return id_email_reminder_subject(inputs)
	if (locale === "fr") return fr_email_reminder_subject(inputs)
	if (locale === "tl") return tl_email_reminder_subject(inputs)
	if (locale === "vi") return vi_email_reminder_subject(inputs)
	if (locale === "ko") return ko_email_reminder_subject(inputs)
	if (locale === "de") return de_email_reminder_subject(inputs)
	if (locale === "ru") return ru_email_reminder_subject(inputs)
	if (locale === "tr") return tr_email_reminder_subject(inputs)
	if (locale === "it") return it_email_reminder_subject(inputs)
	if (locale === "pl") return pl_email_reminder_subject(inputs)
	if (locale === "uk") return uk_email_reminder_subject(inputs)
	if (locale === "hi") return hi_email_reminder_subject(inputs)
	if (locale === "ar") return ar_email_reminder_subject(inputs)
	if (locale === "ms") return ms_email_reminder_subject(inputs)
	if (locale === "bn") return bn_email_reminder_subject(inputs)
	if (locale === "zh-TW") return zh_tw2_email_reminder_subject(inputs)
	if (locale === "zh-HK") return zh_hk2_email_reminder_subject(inputs)
	if (locale === "ur") return ur_email_reminder_subject(inputs)
	if (locale === "fa") return fa_email_reminder_subject(inputs)
	if (locale === "sw") return sw_email_reminder_subject(inputs)
	if (locale === "nl") return nl_email_reminder_subject(inputs)
	return en_email_reminder_subject(inputs)
});